<div class="sf-bar">

  <!-- Search -->
  <form class="sf-search" (ngSubmit)="searcheBenef()" #searchForm="ngForm">

    <div class="sf-mode-toggle">
      <button type="button" class="sf-mode-btn" [class.active]="input_option === 'MAT'" (click)="setMode('MAT')">MAT</button>
      <button type="button" class="sf-mode-btn" [class.active]="input_option === 'CMU'" (click)="setMode('CMU')">CMU</button>
    </div>

    <div class="sf-input-wrap">
      <i class="fa" [ngClass]="searchModeIcon"></i>
      <input class="sf-input"
             type="text"
             name="input_value"
             [(ngModel)]="input_value"
             [placeholder]="searchPlaceHolder"
             autocomplete="off">
    </div>

    <button class="sf-btn-search" type="submit" [disabled]="!input_value || isLoading">
      <i class="fa" [ngClass]="isLoading ? 'fa-spinner fa-spin' : 'fa-search'"></i>
    </button>

    @if (searchAttempted) {
      <button class="sf-btn-reset" type="button" (click)="resetSearch()" title="Nouvelle recherche">
        <i class="fa fa-times"></i>
      </button>
    }

  </form>

  <div class="sf-divider"></div>

  <!-- Beneficiary Detail -->
  <app-benef-detail
    [itemBeneficiare]="itemBeneficiare"
    [isLoading]="isLoading"
    [searchAttempted]="searchAttempted"
    [canEditProfile]="canEditProfile">
  </app-benef-detail>

</div>
